import {
  FinanceResponse,
  MinimalRate,
  Rate,
} from '@upstart/harmony/lib/legos/financingTypes';
import { parseRates } from '@upstart/harmony/lib/response-utils';
import { ParseRatesResult } from '@upstart/harmony/lib/response-utils/parseRates';
import { useEffect, useMemo, useState } from 'react';
import { useAsyncCallback } from 'react-async-hook';
import FinanceResponseService from 'services/FinanceResponseService';

type UseUpstartRatesResult = Omit<
  ParseRatesResult,
  'relevantRates' | 'currentRate'
> & {
  allRates: Rate[];
  highlightedRate?: MinimalRate;
  loadingRates: boolean;
};
export function useUpstartRates(
  response?: FinanceResponse,
): UseUpstartRatesResult {
  const getFinanceResponseRates = useAsyncCallback(
    FinanceResponseService.getRates,
  );
  const [allRates, setAllRates] = useState<Rate[]>([]);
  useEffect(() => {
    if (response) {
      getFinanceResponseRates.execute(response.id).then(({ rates }) => {
        setAllRates(rates);
      });
    } else {
      setAllRates([]);
    }
  }, [response?.id]);
  const {
    financeAmountRates,
    termRates,
    downPaymentRates,
    currentRate: highlightedRate,
  } = useMemo(
    () =>
      parseRates({
        rates: allRates,
        months: response?.data?.months,
        downPayment: response?.data?.downPayment ?? 0,
        financeAmount: response?.data?.financeAmount ?? 0,
      }),
    [
      allRates,
      response?.data?.months,
      response?.data?.downPayment,
      response?.data?.financeAmount,
    ],
  );

  return {
    allRates,
    financeAmountRates,
    termRates,
    downPaymentRates,
    highlightedRate,
    loadingRates: getFinanceResponseRates.loading,
  };
}
